export default __webpack_public_path__ + "static/europa-press-8f8482014efe633f9d00cf3890836037.png";